import { render, staticRenderFns } from "./UsuariosPermissoes.vue?vue&type=template&id=37b6564b&scoped=true&"
import script from "./UsuariosPermissoes.vue?vue&type=script&lang=js&"
export * from "./UsuariosPermissoes.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPermissoes.vue?vue&type=style&index=0&id=37b6564b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6564b",
  null
  
)

export default component.exports